// Backgrounds
export const MERCURY = '#E5E5E5';
// Primary
export const MOUNTAIN_MEADOW = '#11CC88';
/** Mountain Meadow at 12% alpha — used by section labels/chips on light backgrounds. */
export const MOUNTAIN_MEADOW_12 = 'rgba(17, 204, 136, 0.12)';
/** Mountain Meadow at 28% alpha — used as label/chip border on light backgrounds. */
export const MOUNTAIN_MEADOW_28 = 'rgba(17, 204, 136, 0.28)';
/** Mountain Meadow at 35% alpha — card hover border. */
export const MOUNTAIN_MEADOW_35 = 'rgba(17, 204, 136, 0.35)';
/** Mountain Meadow at 40% alpha — strong hover border. */
export const MOUNTAIN_MEADOW_40 = 'rgba(17, 204, 136, 0.40)';
/** OuterSpace at 8% / 10% / 12% alpha — neutral hairline borders on light surfaces. */
export const OUTER_SPACE_08 = 'rgba(36, 54, 54, 0.08)';
export const OUTER_SPACE_10 = 'rgba(36, 54, 54, 0.10)';
export const OUTER_SPACE_12 = 'rgba(36, 54, 54, 0.12)';
/** Section background tints used by v1.7 BUILD/PERSONALIZE/GROW shells. */
export const SECTION_BG_PERSONALIZE = '#F7FAF9';
export const SECTION_BG_GROW = '#F0F5F5';
// Blacks
export const OUTER_SPACE = '#243636';
export const LIMED_SPRUCE = '#3B5252';
export const NEVADA = '#5D7575';
export const GRANNY_SMITH = '#889E9E';
export const SUBMARINE = '#B8CCCC';
export const MYSTIC = '#E2EBEB';
export const WHITE = '#FFF';
export const GEYSER = '#D2DFDF';
// Secondary #1
export const RAIN_FOREST = '#007060';
// Secondary #2
export const CANDLELIGHT = '#FED624';
// Tertiary #1
export const SUNSET_ORANGE = '#FF5252';
// Tertiary #2
export const CORNFLOWER_LILIAC = '#FFB3A2';
// Tertiary #3
export const WINDSOR = '#560A71';
// Tertiary #4
export const TURQUOISE = '#46DED5';
// Tertiary #5
export const DODGER_BLUE = '#1291FF';
export const BLACK_HAZE = '#F4F6F6';
